import { createFirebaseAuth } from "@canucci/base/auth";

export const auth = createFirebaseAuth();
